import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  CircularProgress,
} from '@mui/material'
import '../../styles/pages.css'

interface contentType {
  key: string
  value?: string
}

enum footerStateType {
  yesNoButtons,
  loading,
  refreshButton,
  error,
}

const RequestDialog = ({
  open,
  title,
  content,
  submitRequest,
  waitingTime = 0,
  onClose,
  redirect,
  refreshPopUp = true,
}: {
  open: boolean
  title: string
  content: contentType[]
  submitRequest: ((params?: any) => Promise<void>) | (() => void)
  waitingTime?: number
  onClose: () => void
  redirect?: () => void
  refreshPopUp?: boolean
}) => {
  const [footerState, setFooterState] = useState<footerStateType>(
    footerStateType.yesNoButtons,
  )

  useEffect(() => {
    setFooterState(footerStateType.yesNoButtons)
  }, [open])

  const handleClose = () => {
    setFooterState(footerStateType.yesNoButtons)
    onClose()
  }

  const submit = async () => {
    setFooterState(footerStateType.loading)
    try {
      await submitRequest()
      setTimeout(function () {
        refreshPopUp ? setFooterState(footerStateType.refreshButton) : onClose()
      }, waitingTime)
    } catch (e: any) {
      setFooterState(footerStateType.error)
    }
  }

  const refreshPage = () => {
    window.location.reload()
  }

  return (
    <Dialog onClose={handleClose} open={open} data-testid="dialog">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {content.map((cont, i) => (
          <DialogContentText key={i}>
            {cont.key}
            {cont.value && (
              <>
                : <b>{cont.value}</b>
              </>
            )}
          </DialogContentText>
        ))}
      </DialogContent>
      {footerState === footerStateType.yesNoButtons && (
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={handleClose}>
            No
          </Button>
          <Button variant="outlined" color="secondary" onClick={submit}>
            Yes
          </Button>
        </DialogActions>
      )}
      {footerState === footerStateType.loading && (
        <DialogContent style={{ margin: 'auto' }}>
          <CircularProgress color="secondary" />
        </DialogContent>
      )}
      {footerState === footerStateType.refreshButton && (
        <DialogContent style={{ margin: 'auto' }}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={redirect || refreshPage}
          >
            Click here to see results
          </Button>
        </DialogContent>
      )}
      {footerState === footerStateType.error && (
        <>
          <DialogContent style={{ margin: 'auto' }} className="error">
            Request error, please try again later.
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" color="primary" onClick={handleClose}>
              OK
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default RequestDialog
